<div class="flex h-screen flex-col overflow-hidden">
  <app-landing-header class="sticky top-0 z-20"></app-landing-header>
  <div class="scrollbar overflow-y-auto">
    <main class="bg-secondary-greys-white">
      <router-outlet></router-outlet>
    </main>
    <app-landing-footer></app-landing-footer>
  </div>
</div>
